export class NgSelectMultiple {
    showlimit?: number;
    Header?: boolean;
    Footer?: boolean;
    validatorMessage?: boolean;
    tooltipMessage?: boolean;
    openWhenFocus?: boolean;
    submitted?: boolean;
    validatorAlert?: boolean;
    appendTo?: string;
    loadingText?: string;
    markFirst?: boolean;
}

